<app-loading-screen></app-loading-screen>

<div class="pg-container">

  <div class="row indicator">

    <!-- Main -->
    <div #divIndicatorContainer class="col-12 h-80">
      <!-- changing from col-10 to col-12 to break from not being full-width-->

      <!-- <div [@routeAnimations]="prepareRoute(outlet)"> -->
      <div>
        <router-outlet #outlet="outlet"></router-outlet>
      </div>
    </div>

  </div>

</div>